import { PageLayout, Section } from "../components/PageLayout";
import { WideOpener, AtmoBreak, SideBySide } from "../components/ImageBlocks";
import { useLanguage } from "../contexts/LanguageContext";

const IMPULSE = [
  "Manchmal beginnt Veränderung damit, dass man einen Gedanken nicht mehr wegschiebt.",
  "Freiheit fühlt sich selten spektakulär an. Meistens ist sie leise.",
  "Ein einziger ehrlicher Moment kann mehr bewegen als ein ganzes Jahr Funktionieren.",
  "Wenn man aufhört, sich zu beeilen, hört man plötzlich wieder sich selbst.",
  "Der erste Schritt ist oft kein Schritt, sondern ein Entschluss.",
  "Es gibt Tage, an denen man nichts tut — und trotzdem weiterkommt.",
  "Manchmal ist das Mutigste, nicht weiterzumachen.",
  "Klarheit entsteht selten im Lärm.",
  "Ein kleiner Gedanke kann ein ganzes Leben verschieben.",
  "Man merkt erst, wie schwer etwas war, wenn man es loslässt.",
];

const STIMMEN = [
  "Seit ich aufhöre, Content zu spielen, und anfange, ich selbst zu sein, reagieren die Leute anders.",
  "Ich habe gemerkt, dass meine Reichweite nicht das Problem war — sondern meine Haltung.",
  "Früher habe ich gepostet, um etwas zu erreichen. Heute poste ich, weil ich etwas zu sagen habe.",
  "Ich dachte immer, ich müsste lauter werden. Dabei musste ich nur echter werden.",
  "Seit ich nicht mehr verkaufe, sondern zeige, wer ich bin, kommen die Anfragen von allein.",
  "Ich habe aufgehört, mich zu verstellen — und plötzlich fühlen sich meine Kontakte wie Gespräche an, nicht wie Termine.",
  "Ich habe verstanden, dass Social Selling nicht bedeutet, überall zu sein, sondern dort ich selbst zu sein.",
  "Früher habe ich Content geplant. Heute teile ich Momente — und genau das zieht Menschen an.",
  "Ich habe gemerkt, dass mein Business wächst, sobald ich aufhöre, mich zu vergleichen.",
  "Ich dachte, Positionierung wäre eine Strategie. Jetzt weiß ich: Es ist eine Entscheidung.",
];

const POETIC = [
  "Zwischen zwei Atemzügen liegt manchmal mehr Wahrheit als in einem ganzen Jahr.",
  "Es gibt Wege, die man erst sieht, wenn man stehen bleibt.",
  "Manchmal beginnt ein neues Leben damit, dass man das alte nicht mehr trägt.",
  "Die leisen Dinge sind oft die, die bleiben.",
  "Ein Gedanke kann ein Fenster sein.",
  "Manchmal ist das Licht nicht heller — man selbst ist offener.",
  "Es gibt Momente, die nichts erklären und trotzdem alles verändern.",
  "Manchmal ist der Mut nur ein Flüstern, das man endlich hört.",
  "Zwischen gestern und morgen liegt ein Raum, den man heute nennt.",
  "Manchmal reicht ein Atemzug, um wieder bei sich anzukommen.",
];

function NumberedList({ items, isQuote = false, testId }) {
  return (
    <ol
      data-testid={testId}
      className="list-none space-y-4"
      style={{ color: "#1A1A1A" }}
    >
      {items.map((text, idx) => (
        <li key={idx} className="flex gap-4">
          <span
            className="shrink-0 pt-1 text-xs uppercase tracking-[0.2em]"
            style={{ color: "rgba(26,26,26,0.45)", fontWeight: 500, minWidth: "1.4rem" }}
          >
            {String(idx + 1).padStart(2, "0")}
          </span>
          <span
            className={isQuote ? "italic" : ""}
            style={{ lineHeight: 1.6 }}
          >
            {isQuote ? `„${text}"` : text}
          </span>
        </li>
      ))}
    </ol>
  );
}

export default function Inspiration() {
  return (
    <PageLayout>
      {/* Hero (23:9) + Kapitelüberschrift entfernt — Seite startet direkt mit Impulsen */}

      {/* Section: IMPULSE */}
      <WideOpener
        src="wide-3-3_oeffnung_21-9_v01.jpg"
        alt="Impulse"
        heading="Impulse"
      />

      <Section testId="section-impulse">
        <SideBySide src="IST_impuls_q_v01.jpg" alt="">
          <NumberedList items={IMPULSE} testId="inspiration-impulse-list" />
        </SideBySide>
      </Section>

      {/* Section: STIMMEN — 16:9 entfernt */}
      <WideOpener
        src="wide-3-4_resonanz_21-9_v01.jpg"
        alt="Stimmen"
        heading="Stimmen"
      />

      <Section testId="section-stimmen">
        <SideBySide src="IST_visionen_q_v01.jpg" alt="">
          <NumberedList items={STIMMEN} isQuote testId="inspiration-stimmen-list" />
        </SideBySide>
      </Section>

      {/* Section: POETISCHE MINI TEXTE — nur letztes 16:9 bleibt */}
      <WideOpener
        src="wide-3-6_weite-haltung_21-9_v01.jpg"
        alt="Poetische Mini Texte"
        heading="Poetische Mini Texte"
      />

      <Section testId="section-poetic">
        <SideBySide src="IST_kreis_q_v01.jpg" alt="">
          <NumberedList items={POETIC} testId="inspiration-poetic-list" />
        </SideBySide>
        <AtmoBreak src="3-5_naehe_16_v01_v1.jpg" alt="" />
      </Section>
    </PageLayout>
  );
}
